import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { ScrollTop } from '@/components/element/ScrollTop';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useNavState } from '@/providers/NavStateProvider';
import { useEffect } from 'react';
import { useCurrentPaymentTask } from '@/providers/PaymentTaskProvider';
import { PaymentTaskFileEditForm } from '@/components/features/tasks/payment/[payment_task_id]/PaymentTaskFileEditForm';
import { useParams } from 'react-router-dom';

export const BackofficePaymentTaskFiles = () => {
  const { _w_, _t_, me } = useCurrentTeamMember();
  const { setTitle, setBreadcrumbs } = useNavState();
  const { paymentTask: task } = useCurrentPaymentTask();
  const { purchase_order_id } = useParams();
  useEffect(() => setTitle(`請求書等ファイル一覧`), []);
  useEffect(
    () =>
      setBreadcrumbs([
        { label: `支払タスク一覧`, path: `/w/${_w_!.identifier}/backoffice/payment_tasks` },
        {
          label: `支払タスク詳細`,
          path: `/w/${_w_!.identifier}/backoffice/teams/${_t_!.id}/purchase_orders/${purchase_order_id}/payment_tasks/${
            task!.id
          }`,
        },
      ]),
    []
  );

  return (
    <WorkspaceLayout>
      <ScrollTop />

      <PaymentTaskFileEditForm />
    </WorkspaceLayout>
  );
};
